module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/startup/startup.component.css
// module id = ./src/app/components/startup/startup.component.css
// module chunks = main